import React, { useEffect, useRef, useState, type CSSProperties } from "react"
import { Transition } from "@headlessui/react"
import Alert from "components/Alert"
import { useAlertsContext, type AlertDetail } from "context/alerts"

const GlobalAlert = ({ id, type, message, dismissed }: AlertDetail) => {
  const { deleteAlert } = useAlertsContext()
  const ref = useRef<HTMLDivElement>(null)
  const [show, setShow] = useState(false)
  const [height, setHeight] = useState(0)

  const afterLeave = () => deleteAlert(id)

  useEffect(() => {
    const frameId = requestAnimationFrame(() => {
      if (!dismissed && ref.current) {
        setHeight(ref.current.scrollHeight)
      }
    })

    setShow(!dismissed)

    return () => cancelAnimationFrame(frameId)
  }, [dismissed])

  return (
    <div style={{ "--scroll-height": `${height}px` } as CSSProperties}>
      <Transition
        ref={ref}
        show={show}
        unmount={false}
        as="div"
        enter="transition-all ease-out duration-200"
        enterFrom="h-0"
        enterTo="h-[var(--scroll-height)]"
        leave="transition-all ease-in duration-150"
        leaveFrom="h-[var(--scroll-height)]"
        leaveTo="h-0"
        className="overflow-hidden"
        afterLeave={afterLeave}
      >
        <Alert status={type} className="mt-4">
          {message}
        </Alert>
      </Transition>
    </div>
  )
}

const GlobalAlerts = () => {
  const { alerts } = useAlertsContext()
  return (
    <div className="flex flex-col">
      {alerts.map(alert => (
        <GlobalAlert key={alert.id} {...alert} />
      ))}
    </div>
  )
}

export default GlobalAlerts
